module.exports = __webpack_public_path__ + "static/media/login-banner3.73b580d0.jpg";